/**
 * Map of legacy healic.in long doctor slugs → new short doctor slug.
 * Used to serve and link doctor pages at the old long URLs.
 */
export const OLD_DOCTOR_SLUGS: Record<string, string> = {
  "-Dr-Pankaj-General-Surgeonn-Muzaffarnagar": "pankaj-sharma",
  "Dr-Manish-Daksh-general-physician-Muzaffarnagar": "manish-daksh",
  "Dr.-Akshi-Singhal-ent-Muzaffarnagar": "akshi-singhal",
  "Dr-Charat-Singhal-Orthodpedics-Muzaffarnagar": "charat-singhal",
  "dr-abhinav-prakash-agra-general-laparoscopic-laser-surgeon": "abhinav-prakash",
  "dr-aditya-pratap-singh-general-physician-haridwar": "aditya-pratap-singh",
  
  "dr-akash-singh-general-surgery-indirapuram-ghaziabad": "akash-singh",
  "dr-akash-singh-general-surgery-gurgaon": "akash-singh",
  "dr-akshata-bhatnagar-obstetrics-gynaecology-indirapuram-ghaziabad": "akshata-bhatnagar",
  "dr-amit-kumar-garg-neurosurgeon-indirapuram-ghaziabad": "amit-kumar-garg",
  "dr-ankit-goyal-ent-haridwar": "ankit-goyal",
  "dr-ankit-kumar-orthopedics-sector-50-gurugram": "ankit-kumar",
  
  "dr-amit-kumar-general-surgeon-agra": "amit-kumar",
  "dr-anju-suryapani-gynaecologist-indirapuram-ghaziabad": "anju-suryapani",
  "dr-anupama-gonjhu-gynaecologist-sector-50-gurugram": "dr-anupama-gonjhu-gynaecologist-gurugram",
  "anupama-gonjhu": "dr-anupama-gonjhu-gynaecologist-gurugram",
  
  "dr-anup-mittal-general-physician-indirapuram-ghaziabad": "anup-mittal",
  "dr-arunava-ray-general-physician-sector-50-gurugram": "dr-arunava-ray-general-physician-gurugram",
  "arunava-ray": "dr-arunava-ray-general-physician-gurugram",
  "dr-arundhati-kar-eye-doctor-sector-68-gurugram": "arundhati-kar",
  
  "dr-deepika-yadav-gynaecologist-haridwar": "deepika-yadav",
  "dr-gajender-kumar-soni-general-surgeon-haridwar": "gajender-kumar-soni",
  "dr-garvita-hajela-general-physician-indirapuram-ghaziabad": "garvita-hajela",
  "dr-hemant-kataria-psychiatrist-haridwar": "hemant-kataria",
  "dr-hk-singh-ent-specialist-agra": "hk-singh",
  "dr-joginder-singh-duhan-cardiologist-gurugram": "joginder-singh-duhan",
  "dr-kashish-sachdeva-general-laparoscopic-laser-surgeon-haridwar": "kashish-sachdeva",
  "dr-mahak-indirapuram-gzb-general-physician": "mahak",
  "drmansvisingh-general-physician-gurgaon": "mansvi-singh-general-physician-gurgaon",
  "mansvi-singh": "mansvi-singh-general-physician-gurgaon",
  "dr-meenakshi-singh-obstetrician-gynaecologist-agra": "meenakshi-singh",
  "dr-ms-bajaj-orthopedics-indirapuram-ghaziabad": "ms-bajaj",
  "dr-narendra-kishor-mandal-general-surgeon-gurgaon": "narendra-kishor-mandal",
  "dr-nisha-general-physician-indirapuram-ghaziabad": "nisha",
  "dr-nitin-chaudhary-ent-specialist-indirapuram": "nitin-chaudhary",
  "dr-nupur-sharma-gynaecologist-gurugram": "nupur-sharma",
  "dr-padma-charan-patra-ent-specialist-gurugram": "padma-charan-patra",
  "dr-pranava-prakash-general-physician-gurgaon": "pranava-prakash",
  "dr-rahul-vijayavargiya-gurgaon-gastroenterologist": "rahul-vijayavargiya",
  "dr-rajiv-saxena-general-physician-indirapuram-ghaziabad": "rajiv-saxena",
  "dr-saloni-agrawal-agra-general-physician": "saloni-agrawal",
  
  "dr-shivam-sethi-general-physician-haridwar": "shivam-sethi",
  "dr-shubha-mishra-general-physician-sohna-road-gurugram": "shubha-mishra",
  "dr-surabhi-dhakarey-consultant-obstetrician-gynaecologist-agra": "surabhi-dhakarey",
  "dr-vikas-gupta-haridwar-paediatrics": "vikas-gupta",
  "dr-vineet-jain-general-physician-agra": "dr-vineet-jain-general-physician-agra",
  "dr-vivek-nain-general-physician-agra": "vivek-nain",
  "dr-yashi-singh-general-physician-gastrointestinal-health-indirapuram": "yashi-singh",
  "dr-yaswanth-kumar-pavada-general-physician-indirapuram-ghaziabad": "yaswanth-kumar-pavada",
};

export const LEGACY_DOCTOR_SLUG_BY_CURRENT: Record<string, string> = Object.fromEntries(
  Object.entries(OLD_DOCTOR_SLUGS).map(([legacySlug, currentSlug]) => [currentSlug, legacySlug]),
);

function slugFromDoctorName(name: string) {
  return name
    .toLowerCase()
    .replace(/^dr\.?\s+/i, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

const LEGACY_DOCTOR_SLUG_BY_NAME: Record<string, string> = {
  ...LEGACY_DOCTOR_SLUG_BY_CURRENT,
};

export function doctorProfileSlug(currentSlug: string, doctorName?: string) {
  if (doctorName) {
    const nameSlug = slugFromDoctorName(doctorName);
    if (LEGACY_DOCTOR_SLUG_BY_NAME[nameSlug]) return LEGACY_DOCTOR_SLUG_BY_NAME[nameSlug];
  }
  return LEGACY_DOCTOR_SLUG_BY_CURRENT[currentSlug] ?? currentSlug;
}
